import fetch from "auth/FetchInterceptor";
import requestCacheService from "./RequestCacheService";

const usuarioService = {};

usuarioService.get = async function (params = {}) {
	const {
		page = 0,
		pageSize = 5,
		search = "",
		orderBy = "id",
		orderDirection = "asc",
		filters = {},
	} = params;

	const queryParams = {
		page,
		pageSize,
		search,
		orderBy,
		orderDirection,
		filters,
	};

	return fetch({
		url: "/v1/rest/usuario",
		method: "get",
		params: queryParams,
		headers: { is_paginated: true },
	});
};

usuarioService.getAll = async function () {
	return requestCacheService.cacheRequest(
		"lista_usuarios",
		() => {
			return fetch({
				url: "/v1/rest/usuario",
				method: "get",
			});
		},
		60,
	);
};

usuarioService.post = async function (values) {
	await requestCacheService.limparCache("lista_usuarios");
	return fetch({
		url: "/v1/rest/usuario",
		method: "post",
		data: values,
	});
};

usuarioService.put = async function (values, id) {
	return fetch({
		url: "/v1/rest/usuario/" + id,
		method: "put",
		data: values,
	});
};

usuarioService.getById = async (id) => {
	return fetch({
		url: `/v1/rest/usuario/${id}`,
		method: "get",
	});
};

usuarioService.delete = async (id) => {
	return fetch({
		url: `/v1/rest/usuario/${id}`,
		method: "delete",
	});
};

usuarioService.obterPropriosDados = async () => {
	return fetch({
		url: "/v1/rpc/obter-proprios-dados",
		method: "get",
	});
};

usuarioService.iniciarImportacaoMfit = async (
	email_mfit,
	senha_mfit,
	selectedAlunoIds = [],
	opcoesImportacao = {},
	senha_padrao,
) => {
	return fetch({
		url: "/v1/rpc/importar-mfit",
		method: "post",
		data: {
			email_mfit,
			senha_mfit,
			selectedAlunoIds,
			opcoes_importacao: opcoesImportacao,
			senha_padrao,
		},
	});
};

usuarioService.listarAlunosMfit = async (
	email_mfit,
	senha_mfit,
	incluir_inativos,
) => {
	return fetch({
		url: "/v1/rpc/mfit/listar-alunos",
		method: "post",
		data: { email_mfit, senha_mfit, incluir_inativos },
	});
};

usuarioService.listarAlunosPrime = async (email_prime, senha_prime) => {
	return fetch({
		url: "/v1/rpc/prime/listar-alunos",
		method: "post",
		data: { email_prime, senha_prime },
	});
};

usuarioService.iniciarImportacaoPrime = async (
	email_prime,
	senha_prime,
	opcoesImportacao = {},
	senha_padrao,
) => {
	return fetch({
		url: "/v1/rpc/importar-prime",
		method: "post",
		data: {
			email_prime,
			senha_prime,
			opcoes_importacao: opcoesImportacao,
			senha_padrao,
		},
	});
};

usuarioService.listarAlunosWebdiet = async (email_webdiet, senha_webdiet) => {
	return fetch({
		url: "/v1/rpc/webdiet/listar-alunos",
		method: "post",
		data: { email_webdiet, senha_webdiet },
	});
};

usuarioService.iniciarImportacaoWebdiet = async (
	email_webdiet,
	senha_webdiet,
	selectedAlunoIds = [],
	opcoesImportacao = {},
	senha_padrao,
) => {
	return fetch({
		url: "/v1/rpc/importar-webdiet",
		method: "post",
		data: {
			email_webdiet,
			senha_webdiet,
			selectedAlunoIds,
			opcoes_importacao: opcoesImportacao,
			senha_padrao,
		},
	});
};

usuarioService.atualizarPropriosDados = async function (values) {
	return fetch({
		url: "/v1/rpc/atualizar-proprios-dados",
		method: "put",
		data: values,
	});
};

usuarioService.atualizarEndereco = async function (values) {
	return fetch({
		url: "/v1/rpc/atualizar-endereco",
		method: "put",
		data: values,
	});
};

usuarioService.atualizarUltimaAtividade = async function () {
	return fetch({
		url: "/v1/rpc/atualizar-ultima-atividade",
		method: "put",
	});
};

/**
 * Obtém a lista de usuários que foram indicados pelo usuário atual
 * @returns {Promise<Array>} - Lista de usuários indicados
 */
usuarioService.obterUsuariosIndicados = async function () {
	return fetch({
		url: "/v1/rpc/obter-usuarios-indicados",
		method: "get",
	});
};

usuarioService.getDetalhes = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}`,
		method: "get",
	});
};

usuarioService.getAlunosDoProfissional = async function (id, params = {}) {
	const {
		page = 0,
		pageSize = 10,
		orderBy = "nome",
		orderDirection = "asc",
		search = "",
	} = params;
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/alunos`,
		method: "get",
		params: { page, pageSize, orderBy, orderDirection, search },
	});
};

usuarioService.getRelacaoComAluno = async function (id, idAluno) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/alunos/${idAluno}`,
		method: "get",
	});
};

usuarioService.getCobrancasPlano = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/cobrancas-plano`,
		method: "get",
	});
};

usuarioService.getSaldoCredito = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/saldo-credito`,
		method: "get",
	});
};

usuarioService.concederCredito = async function (id, dados) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/conceder-credito`,
		method: "post",
		data: dados,
	});
};

usuarioService.perdoarCobranca = async function (id, dados) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/perdoar-cobranca`,
		method: "post",
		data: dados,
	});
};

usuarioService.getCobrancasAluno = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/cobrancas-aluno`,
		method: "get",
	});
};

usuarioService.getProfissionaisDoAluno = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/profissionais`,
		method: "get",
	});
};

usuarioService.atualizarPodeImportar = async function (id, origem, ativo) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/pode-importar/${origem}`,
		method: "put",
		data: { ativo },
	});
};

usuarioService.getHistoricoAssinatura = async function (id) {
	return fetch({
		url: `/v1/rpc/usuario-detalhes/${id}/historico-assinatura`,
		method: "get",
	});
};

export default usuarioService;
